var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 187.322 187.322",
    style: {
      enableBackground: "new 0 0 187.322 187.322"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A663"
    },
    points: "101.677,40.71 93.661,0 85.645,40.71 93.661,40.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC80A"
    },
    points: "67.185,47.804 74.127,43.796 46.83,12.548 60.243,51.812  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A663"
    },
    points: "47.804,67.186 51.811,60.243 12.548,46.83 43.795,74.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC80A"
    },
    points: "40.709,93.66 40.71,85.646 0,93.66 40.709,101.677  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A663"
    },
    points: "47.803,120.137 43.796,113.194 12.548,140.491 51.81,127.079  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC80A"
    },
    points: "60.244,135.511 46.83,174.774 74.127,143.527 67.184,139.519  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A663"
    },
    points: "85.645,146.611 93.661,187.322 101.677,146.613 93.661,146.613  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC80A"
    },
    points: "120.137,139.519 113.195,143.525 140.491,174.774 127.079,135.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A663"
    },
    points: "139.519,120.137 135.51,127.077 174.773,140.491 143.525,113.194  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC80A"
    },
    points: "187.322,93.66 146.612,85.645 146.613,93.66 146.612,101.676  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A663"
    },
    points: "139.518,67.184 143.525,74.126 174.773,46.83 135.509,60.243  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC80A"
    },
    points: "127.078,51.812 140.491,12.548 113.193,43.796 120.136,47.804  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD633"
    },
    d: "M93.661,45.265v96.793c26.729,0,48.397-21.668,48.397-48.397S120.39,45.265,93.661,45.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CA19"
    },
    d: "M45.265,93.661c0,26.729,21.668,48.397,48.396,48.397V45.265 C66.933,45.265,45.265,66.933,45.265,93.661z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.04a72ae949bab08e2f81e6f21f3ffdcb.svg";
export { ForwardRef as ReactComponent };